import { render, staticRenderFns } from "./LetsGetToKnow.vue?vue&type=template&id=25114786"
import script from "./LetsGetToKnow.vue?vue&type=script&lang=js"
export * from "./LetsGetToKnow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports